var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "placeholder-component" },
    [
      _c("div", { staticClass: "component-title" }, [
        _vm._v(_vm._s(_vm.title)),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-content" },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.formData, "label-width": "100px" } },
            [
              _c("el-form-item", { attrs: { label: "配置图片" } }, [
                _c("div", { staticClass: "image-uploader" }, [
                  _c(
                    "div",
                    {
                      staticClass: "image-preview",
                      on: { click: _vm.triggerSelect },
                    },
                    [
                      _vm.getImageUrl(_vm.formData.imageUrl)
                        ? _c("img", {
                            staticClass: "preview-img",
                            attrs: {
                              src: _vm.getImageUrl(_vm.formData.imageUrl),
                              alt: "配置图片预览",
                            },
                          })
                        : _c("div", { staticClass: "image-placeholder" }, [
                            _c("i", { staticClass: "el-icon-picture-outline" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "placeholder-text" }, [
                              _vm._v("点击上传图片"),
                            ]),
                          ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    ref: "fileInput",
                    staticStyle: { display: "none" },
                    attrs: { type: "file", accept: "image/*" },
                    on: { change: _vm.handleFileChange },
                  }),
                  _vm._v(" "),
                  _vm.formData.imageUrl
                    ? _c(
                        "div",
                        { staticClass: "uploader-actions" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: { click: _vm.removeImage },
                            },
                            [_vm._v("移除")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "action-buttons" },
        [
          _c(
            "el-button",
            { attrs: { type: "success" }, on: { click: _vm.confirmSave } },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.previewVisible,
            title: "预览图片",
            width: "600px",
            "before-close": _vm.handlePreviewClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "preview-dialog-content" }, [
            _c("img", {
              staticClass: "preview-image",
              staticStyle: {
                "max-width": "100%",
                height: "auto",
                display: "block",
                margin: "0 auto",
              },
              attrs: { src: _vm.previewImageUrl, alt: "预览图片" },
            }),
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.previewVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }